module.exports = __webpack_public_path__ + "img/finland-breast-cancer-female.fe71c52c.png";